var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-banner alert border-0 rounded-0 py-2 py-md-3 text-center mb-0",style:(_vm.style),attrs:{"role":"alert"},domProps:{"innerHTML":_vm._s(_vm.text)}})
}
var staticRenderFns = []

export { render, staticRenderFns }